module.exports = __webpack_public_path__ + "fonts/pacifico-webfont.4f33c509.woff2";